"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = provideRenderToLayer;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _uuid = _interopRequireDefault(require("../utils/uuid"));

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

/**
 * Предоставляет в оборачиваемый `Target` методы монтирования/размонтирования в отделную ноду в DOM.
 *
 *  @provideRenderToLayer
 *  class Popup extends Component {
 *
 *    openPopup = () => {
 *      this.popupElement = this.props.renderToLayer(
 *        <div>
 *          <button onClick={this.closePopup}>
 *            Закрыть попап
 *          </button>
 *        </div>
 *      )
 *    }
 *
 *    closePopup = () => {
 *      this.props.unrenderAtLayer(this.popupElement)
 *    }
 *
 *    render() {
 *      return (
 *        <button onClick={this.openPopup}>
 *          Открыть попап
 *        </button>
 *      )
 *    }
 *
 *  }
 *
 * Передает в оборачиваемый компонент следующие props:
 * - renderToLayer(element) - монтирует переданный `element` в отделную ноду
 * - unrenderAtLayer(element) - размонтирует `element`
 */
function provideRenderToLayer(Target) {
  var _temp;

  return _temp = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(ProvideRenderToLayer, _Component);

    var _super = _createSuper(ProvideRenderToLayer);

    function ProvideRenderToLayer() {
      var _this;

      (0, _classCallCheck2.default)(this, ProvideRenderToLayer);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));
      _this.elements = [];
      _this.state = {
        isOpened: false
      };

      _this.renderToLayer = function (element, props) {
        var key = (0, _uuid.default)();
        var resultElement = (0, _react.cloneElement)(element, (0, _extends2.default)({}, props, {
          key: key,
          isOpened: true
        }));

        _this.elements.push(resultElement);

        _this.mountPortal();

        return resultElement;
      };

      _this.unrenderAtLayer = function (element) {
        var elementIndex = _this.elements.indexOf(element);

        if (elementIndex < 0) return Promise.resolve();
        return new Promise(function (resolve) {
          var _containerRef = element.props.containerRef;
          var closedElement = (0, _react.cloneElement)(element, {
            isOpened: false,
            containerRef: function containerRef(ref) {
              if (_containerRef) _containerRef(ref);
              resolve(closedElement);
            }
          });
          _this.elements[elementIndex] = closedElement;

          _this.mountPortal();
        }).then(function (closedElement) {
          _this.elements = _this.elements.filter(function (el) {
            return el !== closedElement;
          });
          if (_this.elements.length === 0) _this.unmountPortal();
        });
      };

      return _this;
    }

    (0, _createClass2.default)(ProvideRenderToLayer, [{
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.elements = [];
        this.unmountPortal();
      }
    }, {
      key: "getContentContainerNode",
      value: function getContentContainerNode() {
        if (!this.node) {
          this.node = document.createElement('div');
          document.body.appendChild(this.node);
        }

        return this.node;
      }
    }, {
      key: "mountPortal",
      value: function mountPortal() {
        this.setState({
          isOpened: true
        });
      }
    }, {
      key: "unmountPortal",
      value: function unmountPortal() {
        if (this.node) {
          this.setState({
            isOpened: false
          });
          document.body.removeChild(this.node);
          this.node = null;
        }
      }
    }, {
      key: "render",
      value: function render() {
        return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(Target, (0, _extends2.default)({}, this.props, {
          renderToLayer: this.renderToLayer,
          unrenderAtLayer: this.unrenderAtLayer
        })), this.state.isOpened && (0, _reactDom.createPortal)(_react.default.createElement(_react.default.Fragment, null, this.elements), this.getContentContainerNode()));
      }
    }]);
    return ProvideRenderToLayer;
  }(_react.Component), _temp;
}